export const makeDictionary = (key = '') => (currentValues, originalValues = []) =>
  originalValues.map(originalValue => ({
    ...originalValue,
    title: originalValue?.[key]
  }))
